'use es6';

import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UIAlert from 'UIComponents/alert/UIAlert';
import { SMART_LOGIN_COOKIE } from '../../constants/SmartLogin';
import styled from 'styled-components';
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink'; // import enviro from 'enviro';

import UIFlex from 'UIComponents/layout/UIFlex';
import { useState, useEffect } from 'react';
import { trackSmartLoginOptOut } from '../../lib/tracker';
import { useLocation } from 'react-router-dom';
import { getDomain } from '../../utils/urls';
import { getCookie } from 'hub-http/helpers/cookies';
const StyledContainer = styled.div.withConfig({
  displayName: "BetaLoginBanner__StyledContainer",
  componentId: "sc-56w3nz-0"
})(["max-width:425px;margin-top:10px;margin-bottom:48px;"]);
export default function BetaLoginBanner() {
  const [visible, setVisible] = useState(false); // const [feedbackOpened, setFeedbackOpened] = useState(false);

  const optOut = () => {
    // Cookie should expire immediately
    const domain = getDomain();
    const userEmail = getCookie(SMART_LOGIN_COOKIE, document.cookie);
    document.cookie = `${SMART_LOGIN_COOKIE}=false;Path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=${domain}`;
    trackSmartLoginOptOut(userEmail);
    window.location.href = `/login${window.location.search}`;
  };

  const location = useLocation();
  useEffect(() => {
    setVisible(location.pathname.startsWith('/beta')); // if (!feedbackOpened) {
    //   const script = document.createElement('script');
    //   script.src = enviro.isQa()
    //     ? '//js-na1.hs-scriptsqa.com/883106956.js'
    //     : '//js-na1.hs-scripts.com/22330291.js';
    //   script.id = 'hs-script-loader';
    //   script.async = true;
    //   script.defer = true;
    //   document.body.appendChild(script);
    //   setFeedbackOpened(true);
    // }
  }, [location //  feedbackOpened
  ]);
  return visible ? /*#__PURE__*/_jsx(UIFlex, {
    align: "center",
    justify: "center",
    direction: "column",
    children: /*#__PURE__*/_jsx(StyledContainer, {
      children: /*#__PURE__*/_jsx(UIAlert, {
        titleText: I18n.text('login.smartLogin.betaBanner.title'),
        type: "info",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "login.smartLogin.betaBanner.optOutButton_jsx",
          options: {
            onClick: optOut,
            size: 'extra-small'
          },
          elements: {
            Link: UILink
          }
        })
      })
    })
  }) : /*#__PURE__*/_jsx(_Fragment, {});
}